import type React from 'react';
import { useSWRConfig } from 'swr';
import Styles from './statuses.module.scss';
import { StatusHandleClientButtons } from '~/components/common/statuses/StatusHandleClientButtons';
import {
  IN_ESTIMATION,
  OWN_IN_ESTIMATION,
  SEND_ESTIMATE
} from '~/models/Status';
import { ScheduleInputNavigation } from '~/components/common/visit_schedule/ScheduleInputNavigation';
import { ESTIMATION_BY } from '~/models/Deal';
import { useDealContext } from '~/context/DealContext';
import { dealCacheKey } from '~/hooks/useDeals';

export const NowAccepting: React.FC = () => {
  const deal = useDealContext();
  const { mutate: globalMutate } = useSWRConfig();
  return (
    <div>
      {deal.dealVendorCompanies.length === 0 ? (
        <>
          <h3 className={Styles.Title}>施工会社を選択してください</h3>
          <StatusHandleClientButtons
            forwardDisabled
            nextStatusId={SEND_ESTIMATE}
          />
        </>
      ) : (
        <>
          {deal.dealVendorCompanies[0].vendorCompany === null ||
          deal.estimationBy === ESTIMATION_BY.COMPANY ? (
            <>
              <h3 className={Styles.Title}>ステータスを進めてください</h3>
              <StatusHandleClientButtons
                nextStatusId={
                  deal.dealVendorCompanies[0].vendorCompany === null
                    ? OWN_IN_ESTIMATION
                    : IN_ESTIMATION
                }
              />
            </>
          ) : (
            <>
              <h3 className={Styles.Title}>
                施工会社がステータスを進めるまでお待ち下さい
              </h3>
              {deal.inspectionBy === 'company' && (
                <ScheduleInputNavigation
                  deal={deal}
                  handleMutate={async (): Promise<void> => {
                    await globalMutate(dealCacheKey(deal.id));
                  }}
                />
              )}
              <StatusHandleClientButtons
                forwardDisabled
                nextStatusId={IN_ESTIMATION}
              />
            </>
          )}
        </>
      )}
    </div>
  );
};
